import { IAppState, IQuickLink } from '../../../../common/state';
import { getGroupedLinks } from './groupLinks';
import { isArrayWithItems } from '../../../../utils';

export function linkGroupsSelector(state: IAppState): IQuickLink[][] | null {
  const links = state.results.quickLinks && state.results.quickLinks.links;
  if (links === null) {
    return null;
  }

  const formattedLinks = getGroupedLinks(links);

  return isArrayWithItems(formattedLinks) ? formattedLinks : null;
}
